import {registerTemplate } from '@contentpepper-publisher/theme-dimo';

export const availableTemplates: any = [registerTemplate()];

export const activeTemplates = ['theme-dimo'];
